import { colors } from "../../utils/styled/_variables.styled"
import Icon from "../Icon/Icon"

export default function RelatedContentTitle({
	title, titleUrl, titleUrlTarget, subtitle
}) {
	const titletag = titleUrl ? <a href={titleUrl} target={titleUrlTarget ? '_blank' : '_self'} rel="noreferrer">
		<h2>{title} <Icon icon="link" color={colors.infiosGray} width="27" height="20" /></h2>
	</a> : title ? <h2>{title}</h2> : null
	return <div className="rel-content__section__title">
		{subtitle && <p className="rel-content__section__subtitle">{subtitle}</p>}
		{titletag}
	</div>
}
